import constate from 'constate';
import React, { useReducer } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'query-string';
import merge from 'lodash/merge';
import assign from 'lodash/assign';
import repo from 'service/repository';
import { isAccessTokenError } from 'utils/api-helper';
import { createReducer } from 'utils/reducers-helper';
import get from 'lodash/get';
import { PATHS } from 'config';

export const CHANGE_TAB = 'CHANGE_TAB';
export const USER_DATA = 'USER_DATA';
export const USER_LICENSE_PLATES = 'USER_LICENSE_PLATES';

export const TOGGLE_DIST_SELECTOR = 'TOGGLE_DIST_SELECTOR';
export const CHANGE_TYPE = 'CHANGE_TYPE';
export const USER_ORDERS = 'USER_ORDERS';
export const START_LOADING = 'START_LOADING';
export const START_LOAD_MORE = 'START_LOAD_MORE';
export const FINISH_LOAD_MORE = 'FINISH_LOAD_MORE';
export const SHOW_ORDER_DIALOG = 'SHOW_ORDER_DIALOG';
export const ACTIVE_LICENSE_PLATES = 'ACTIVE_LICENSE_PLATES';
export const CHANGE_ACTIVE_LICENSE_PLATES = 'CHANGE_ACTIVE_LICENSE_PLATES';
export const CHANGE_ORDER_CHECKBOX_DATA = 'CHANGE_ORDER_CHECKBOX_DATA';
export const ORDER_SUMMARY = 'ORDER_SUMMARY';
export const DETECT_UBN = 'DETECT_UBN';
export const SEND_REPORT_STATE = 'SEND_REPORT_STATE';
export const ACTIVATE_SEND_BUTTON = 'ACTIVATE_SEND_BUTTON';
export const SHOW_ORDER_DIALOG_CALENDAR = 'SHOW_ORDER_DIALOG_CALENDAR';
export const SELECT_CALENDAR_DATE = 'SELECT_CALENDAR_DATE';
export const DATE_CONFIRM = 'DATE_CONFIRM';

const useUser = () => {
  const history = useHistory();
  const location = useLocation();
  const urlSearch = qs.parse(location.search).tab || 'profile';

  const initState = {
    currentTab: urlSearch,
    loading: true,
    userData: undefined,
    userLicensePlates: [],

    totalUserOrders: [],
    totalPage: 1,
    currentUserOrders: [],
    currentPage: 1,
    showOrdersPerTime: 10,
    currentType: '',
    loadMore: false,
    loadingMore: false,

    orderDialogShow: false,
    orderDialogLoading: true,
    noOrders: false,
    activeLicensePlatesShow: true,
    activeLicensePlates: [],
    orderSelectPlates: '',
    orderCheckboxData: [
      { id: 'refueling', value: '加油', isChecked: false },
      { id: 'parking', value: '停車', isChecked: false },
      { id: 'on_street_parking', value: '路邊停車', isChecked: false },
      { id: 'lease', value: '月租車位', isChecked: false },
      { id: 'vehicle_maintenance', value: '汽車美容', isChecked: false },
      { id: 'vehicle_repair', value: '維修保養', isChecked: false },
      { id: 'wash_car', value: '洗車', isChecked: false },
    ],
    startDate: new Date(),
    endDate: new Date(),
    orderStartDate: '',
    orderEndDate: '',
    ubn: '',
    ubnAvailable: false,
    sendReportState: 'init',
    activateSendButton: false,
    showOrderDialogCalendar: false,
    dateSelected: false,
  };

  const changeTab = (state, payload) => merge({}, state, { currentTab: payload });
  const userData = (state, payload) => merge({}, state, { userData: payload, loading: false });
  const userLicensePlates = (state, payload) => merge({}, state, { userLicensePlates: payload, loading: false });

  const userOrders = (state, payload) =>
    assign({}, state, {
      totalUserOrders: payload.ordersData,
      totalPage: payload.totalPage,
      currentUserOrders: payload.currentUserOrders,
      currentPage: payload.currentPage,
      loadMore: payload.currentUserOrders.length < payload.ordersData.length,
      loading: false,
    });
  const startLoading = state => merge({}, state, { loading: true });
  const startLoadMore = state => merge({}, state, { loadingMore: true });
  const finishLoadMore = (state, payload) => merge({}, state, payload);
  const changeType = (state, payload) => {
    return merge({}, state, { currentType: payload === 'ALL' ? '' : payload });
  };
  const showOrderDialog = (state, payload) => merge({}, state, { showOrderDialog: payload });

  // order--------------------------------------------------------

  const orderSummary = (state, payload) => merge({}, state, payload);

  const activeLicensePlates = (state, payload) =>
    merge({}, state, {
      activeLicensePlates: payload,
      orderSelectPlates: payload[0],
    });

  const changeActiveLicensePlates = (state, payload) =>
    merge({}, state, { orderSelectPlates: payload, sendReportState: 'init' });
  const changeOrderCheckboxData = (state, payload) =>
    assign({}, state, {
      orderCheckboxData: payload,
      sendReportState: 'init',
    });
  const showOrderDialogCalendar = (state, payload) =>
    merge({}, state, { showOrderDialogCalendar: payload, endReportState: 'init' });
  const selectCalendarDate = (state, { startDate, endDate }) => merge({}, state, { startDate, endDate });

  const detectUbn = (state, payload) => {
    const ubnAvailable = payload.match('[0-9]{8}$') ? true : false;
    return assign({}, state, { ubn: payload, ubnAvailable, sendReportState: 'init' });
  };
  const dateConfirm = state => {
    const { startDate, endDate } = state;
    let orderStartDate = `${startDate.getFullYear()}.${(startDate.getMonth() + 1 > 9 ? '' : '0') +
      (startDate.getMonth() + 1)}.${(startDate.getDate() > 9 ? '' : '0') + startDate.getDate()}`;
    let orderEndDate = `${endDate.getFullYear()}.${(endDate.getMonth() + 1 > 9 ? '' : '0') +
      (endDate.getMonth() + 1)}.${(endDate.getDate() > 9 ? '' : '0') + endDate.getDate()}`;
    return merge({}, state, { orderStartDate, orderEndDate, showOrderDialogCalendar: false, dateSelected: true });
  };
  const activateSendButton = state => {
    const result =
      state.orderStartDate !== '' &&
      state.orderEndDate !== '' &&
      state.orderCheckboxData.filter(x => x.isChecked).length !== 0 &&
      (state.ubn === '' || state.ubnAvailable === true);
    return merge({}, state, { activateSendButton: result });
  };
  const sendReportState = (state, payload) => merge({}, state, { sendReportState: payload });

  const reducer = createReducer(
    {
      [CHANGE_TAB]: changeTab,
      [USER_DATA]: userData,
      [USER_LICENSE_PLATES]: userLicensePlates,
      [USER_ORDERS]: userOrders,
      [START_LOADING]: startLoading,
      [START_LOAD_MORE]: startLoadMore,
      [FINISH_LOAD_MORE]: finishLoadMore,
      [CHANGE_TYPE]: changeType,
      [SHOW_ORDER_DIALOG]: showOrderDialog,

      [ORDER_SUMMARY]: orderSummary,
      [ACTIVE_LICENSE_PLATES]: activeLicensePlates,
      [CHANGE_ACTIVE_LICENSE_PLATES]: changeActiveLicensePlates,
      [CHANGE_ORDER_CHECKBOX_DATA]: changeOrderCheckboxData,
      [SHOW_ORDER_DIALOG_CALENDAR]: showOrderDialogCalendar,
      [SELECT_CALENDAR_DATE]: selectCalendarDate,
      [DATE_CONFIRM]: dateConfirm,
      [DETECT_UBN]: detectUbn,
      [SEND_REPORT_STATE]: sendReportState,
      [ACTIVATE_SEND_BUTTON]: activateSendButton,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  const errorHandling = err => {
    if (isAccessTokenError(err)) {
      history.push({ pathname: PATHS.REDIRECT, search: `login=expired` });
    } else {
      console.log(err);
    }
  };

  const loadUserData = async () => {
    const [err, data] = await repo.fetchMe();
    if (err) {
      errorHandling(err);
    } else {
      dispatch({ type: USER_DATA, payload: data });
    }
  };

  const loadUserLicensePlates = async () => {
    const [err, data] = await repo.fetchLicensePlates();
    if (err) {
      errorHandling(err);
    } else {
      dispatch({ type: USER_LICENSE_PLATES, payload: data });
    }
  };

  // for init loading, change dist & type
  const loadUserOrders = async (type = state.currentType) => {
    dispatch({ type: START_LOADING });
    type = type === '' ? null : type;
    const [err, data] = await repo.fetchOrders(type, 1);
    if (err) {
      errorHandling(err);
    } else {
      data.currentUserOrders = data.ordersData.slice(0, state.showOrdersPerTime);
      dispatch({ type: USER_ORDERS, payload: data });
    }
  };

  const changingType = key => {
    dispatch({
      type: CHANGE_TYPE,
      payload: key,
    });
    loadUserOrders(key);
  };

  // 拉取更多
  const loadMore = async () => {
    dispatch({ type: START_LOAD_MORE });
    const newOrdersLength = state.currentUserOrders.length + state.showOrdersPerTime;
    if (newOrdersLength < state.totalUserOrders.length) {
      dispatch({
        type: FINISH_LOAD_MORE,
        payload: {
          currentUserOrders: state.totalUserOrders.slice(0, newOrdersLength),
          loadMore: true,
          loadingMore: false,
        },
      });
    } else {
      if (state.currentPage < state.totalPage) {
        const [err, data] = await repo.fetchOrders(state.currentType, 1);
        if (err) {
          errorHandling(err);
        } else {
          const totalUserOrders = state.totalUserOrders.concat(data.ordersData);
          dispatch({
            type: FINISH_LOAD_MORE,
            payload: {
              totalUserOrders,
              currentUserOrders: totalUserOrders.slice(0, newOrdersLength),
              currentPage: data.currentPage,
              loadMore: true,
              loadingMore: false,
            },
          });
        }
      } else {
        dispatch({
          type: FINISH_LOAD_MORE,
          payload: {
            currentUserOrders: state.totalUserOrders,
            loadMore: false,
            loadingMore: false,
          },
        });
      }
    }
  };

  // order report dialog ----------------------------------------------------------------------

  const loadOrderReport = async () => {
    const [meErr, meData] = await repo.fetchMe();
    const [sumErr, sumData] = await repo.fetchOrdersSummary();
    const [licenseErr, licenseData] = await repo.fetchActiveLicensePlates();

    console.log(sumData);

    // 抓取me
    if (meErr) {
      errorHandling(meErr);
    } else {
      dispatch({ type: USER_DATA, payload: meData });
      if (meData.receipt.type === 'b2b') {
        dispatch({ type: DETECT_UBN, payload: meData.receipt.ubn });
      }
    }

    // 抓取使用服務
    if (sumErr) {
      errorHandling(sumErr);
    } else {
      dispatch({
        type: ORDER_SUMMARY,
        payload: {
          noOrders: false,
          orderDialogLoading: false,
          activeLicensePlatesShow: false,
          orderCheckboxData: [{ id: 'lease', value: '月租車位', isChecked: false }],
          orderCheckedIds: ['lease'],
        },
      });

      return;
      let filterData = Object.entries(sumData).filter(([key, value]) => key.match('Transaction'));
      if (filterData.every(d => d[1] === false)) {
        dispatch({
          type: ORDER_SUMMARY,
          payload: {
            noOrders: true,
            orderDialogLoading: false,
          },
        });
      } else if (
        filterData.every(d => {
          return d[0] === 'isPaidLeaseTransactionTypePresent' ? d[1] === true : d[1] === false;
        })
      ) {
        dispatch({
          type: ORDER_SUMMARY,
          payload: {
            noOrders: true,
            orderDialogLoading: false,
            activeLicensePlatesShow: false,
            orderCheckboxData: [{ id: 'lease', value: '月租車位', isChecked: false }],
            orderCheckedIds: ['lease'],
          },
        });
      } else {
        dispatch({
          type: ORDER_SUMMARY,
          payload: {
            noOrders: false,
            orderDialogLoading: false,
          },
        });
      }
    }

    // 抓取使用過車牌
    if (licenseErr) {
      errorHandling(licenseErr);
    } else {
      dispatch({ type: ACTIVE_LICENSE_PLATES, payload: licenseData });
    }
  };

  const sendReport = async () => {
    dispatch({ type: SEND_REPORT_STATE, payload: 'sending' });
    const [err] = await repo.sendUserReports(
      state.orderCheckboxData.filter(x => x.isChecked).map(x => x.id),
      state.orderSelectPlates,
      state.orderStartDate,
      state.orderEndDate,
      state.ubn
    );
    if (err) {
      const status = get(err, 'request.status');
      if (status === 422) {
        dispatch({ type: SEND_REPORT_STATE, payload: 'cannot send' });
      } else {
        console.log(err);
      }
    } else {
      dispatch({ type: SEND_REPORT_STATE, payload: 'sended' });
    }
  };

  return {
    state,
    dispatch,
    loadUserData,
    loadUserLicensePlates,
    loadUserOrders,
    loadMore,
    changingType,
    loadOrderReport,
    sendReport,
  };
};

const [UserProvider, useUserContext] = constate(useUser);

const UserProviderWrapper = Component => {
  return () => {
    return (
      <UserProvider>
        <Component />
      </UserProvider>
    );
  };
};

export { UserProvider, UserProviderWrapper, useUserContext };
